import React from "react";
import styles from "./FilterClub.module.css";

const ImageScroller = ({ data, selectedItems, setSelectedItems }) => {
  const toggleSelect = (id) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = prevSelectedItems.includes(id)
        ? prevSelectedItems.filter((item) => item !== id)
        : [...prevSelectedItems, id];
      return updatedSelectedItems;
    });
  };

  return (
    <div className={styles.imageScrollerContainer}>
      {data?.map(({ _id, image, clubname }) => (
        <div
          key={_id}
          className={styles.imageScrollerItem}
          onClick={() => toggleSelect(_id)}
          style={{
            transform: selectedItems.includes(_id) ? "scale(1.1)" : "none",
            border: selectedItems.includes(_id) ? "2px solid #007bff" : "none",
            borderRadius: selectedItems.includes(_id) ? "10px" : "none"
          }}
        >
          <img src={image} alt={clubname} />
          <p>{clubname}</p>
        </div>
      ))}
    </div>
  );
};

export default ImageScroller;
